var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 1.4V1.9H7.7H12.6C13.0974 1.9 13.5 2.30264 13.5 2.8V8.4C13.5 8.89736 13.0974 9.3 12.6 9.3H9.2449H8.46024L8.7917 10.0112L10.2861 13.2177C10.2861 13.2177 10.2862 13.2178 10.2862 13.2179C10.3472 13.3496 10.2514 13.5 10.1059 13.5C10.0294 13.5 9.9595 13.4557 9.92679 13.3857L8.15301 9.58839L7.2 9.8V13.3021C7.2 13.411 7.11091 13.5 7.0021 13.5H6.9979C6.88909 13.5 6.8 13.411 6.8 13.3021V9.8L5.84699 9.58839L4.07321 13.3857C4.0732 13.3857 4.0732 13.3857 4.07319 13.3858C4.04047 13.4557 3.97057 13.5 3.8941 13.5H3.8934C3.74887 13.5 3.65245 13.3498 3.71393 13.2177L5.2083 10.0112L5.53976 9.3H4.7551H1.4C0.902642 9.3 0.5 8.89736 0.5 8.4V2.8C0.5 2.30264 0.902642 1.9 1.4 1.9H6.3H6.8V1.4V0.7C6.8 0.589742 6.88974 0.5 7 0.5C7.11026 0.5 7.2 0.589742 7.2 0.7V1.4ZM11.9 8.9C12.5625 8.9 13.1 8.36254 13.1 7.7V3.5C13.1 2.83746 12.5625 2.3 11.9 2.3H2.1C1.43746 2.3 0.9 2.83746 0.9 3.5V7.7C0.9 8.36254 1.43746 8.9 2.1 8.9H6.3H7.7H11.9Z",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC16);
export default __webpack_public_path__ + "static/media/c16.f09d3a8e5f9cd3bee3da079455d1e733.svg";
export { ForwardRef as ReactComponent };